/**
 * HeroSplit Schema
 * Schema-driven settings
 */
export default {
  id: 'herosplit',
  version: 1,
  title: 'Hero: раздельный',
  description: 'Раздельный hero-блок: изображение с одной стороны, текст и кнопки с другой',
  icon: 'Columns2',
  category: 'hero',

  // Hero секции используют min-height, padding не применяется
  'x-styles': {
    paddingTop: 0,
    paddingBottom: 0
  },

  fields: [
    {
      group: 'Контент',
      fields: [
        {
          key: 'title',
          type: 'text',
          label: 'Заголовок',
          placeholder: 'Введите заголовок',
          defaults: { size: '4xl', weight: 'bold', color: 'inherit' }
        },
        {
          key: 'subtitle',
          type: 'text',
          label: 'Подзаголовок',
          placeholder: 'Введите описание',
          multiline: true,
          rows: 3,
          defaults: { size: 'lg', weight: 'normal', color: 'secondary' }
        }
      ]
    },
    {
      group: 'Изображение',
      fields: [
        {
          key: 'image',
          type: 'image',
          label: 'Изображение'
        },
        {
          key: 'imagePosition',
          type: 'select',
          label: 'Позиция изображения',
          options: [
            { value: 'left', label: 'Слева' },
            { value: 'right', label: 'Справа' }
          ]
        }
      ]
    },
    {
      group: 'Оформление',
      fields: [
        {
          key: 'verticalAlign',
          type: 'select',
          label: 'Вертикальное выравнивание',
          options: [
            { value: 'top', label: 'Сверху' },
            { value: 'center', label: 'По центру' },
            { value: 'bottom', label: 'Снизу' }
          ]
        },
        {
          key: 'height',
          type: 'select',
          label: 'Высота',
          mode: 'grid',
          columns: 2,
          options: [
            { value: 'small', label: 'Маленькая' },
            { value: 'medium', label: 'Средняя' },
            { value: 'large', label: 'Большая' },
            { value: 'fullscreen', label: 'На весь экран' }
          ]
        }
      ]
    },
    {
      group: 'Кнопки',
      fields: [
        {
          key: 'buttons',
          type: 'buttonList',
          label: 'Кнопки действий',
          variants: ['primary', 'secondary', 'outline']
        }
      ]
    }
  ],

  default: {
    title: { text: 'Создайте что-то удивительное' },
    subtitle: { text: 'Простой и удобный инструмент для создания современных веб-сайтов без кода' },
    image: 'https://placehold.co/800x1000/e2e8f0/64748b?text=Image',
    imagePosition: 'right',
    verticalAlign: 'center',
    height: 'large',
    buttons: [
      { id: '1', text: 'Начать бесплатно', variant: 'primary', link: '#' },
      { id: '2', text: 'Узнать больше', variant: 'outline', link: '#' }
    ]
  },

  migrate(data, fromVersion) {
    if (!fromVersion || fromVersion < 1) {
      const migrated = { ...this.default, ...data };
      ['title', 'subtitle'].forEach(key => {
        if (typeof migrated[key] === 'string') {
          migrated[key] = { text: migrated[key] };
        }
      });
      return migrated;
    }
    return data;
  }
};
